import React from 'react';

import Presentation, { Props as PresentationProps } from './Presentation';

const ResetPassword = (props: PresentationProps) => <Presentation {...props} />;

export default ResetPassword;
